module.exports = __webpack_public_path__ + "static/media/venture_capital_support.3a501091.svg";